import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(32, 32, 32, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  width: 480px;
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #202020;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Body = styled.div`
  margin-top: 24px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #202020;
  margin-bottom: 8px;
  display: block;
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 44px 12px 16px;
  border: none;
  border-radius: 12px;
  background: #f5f5f5;
  font-size: 14px;
  color: #202020;
`;

export const SearchIcon = styled.img`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  border-radius: 24px;
  border: 1px solid #009DFF;
  background: #fff;
  color: #009DFF;
  font-weight: 500;
  cursor: pointer;
`;

export const ImportButton = styled.button`
  padding: 10px 24px;
  border-radius: 24px;
  border: none;
  background: #009DFF;
  color: #fff;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const ImportIcon = styled.img`
  width: 16px;
  height: 16px;
`;
